/**
 * Terrain type definitions for the tile map system.
 * Defines the different terrain types and their properties.
 */

export enum TerrainType {
  GRASS = 'grass',
  DIRT = 'dirt',
  STONE = 'stone',
  WATER = 'water',
  CLIFFS = 'cliffs',
  MINE_NODE = 'mine_node',
}

/**
 * Terrain properties defining behavior for each terrain type.
 */
export interface TerrainProperties {
  /** Whether units can traverse this terrain type */
  traversable: boolean;
  /** Whether buildings can be placed on this terrain type */
  buildable: boolean;
}

/**
 * Terrain properties map for each terrain type.
 */
export const TERRAIN_PROPERTIES: Record<TerrainType, TerrainProperties> = {
  [TerrainType.GRASS]: {
    traversable: true,
    buildable: true,
  },
  [TerrainType.DIRT]: {
    traversable: true,
    buildable: true,
  },
  [TerrainType.STONE]: {
    traversable: true,
    buildable: true,
  },
  [TerrainType.WATER]: {
    traversable: false,
    buildable: false,
  },
  [TerrainType.CLIFFS]: {
    traversable: false,
    buildable: false,
  },
  [TerrainType.MINE_NODE]: {
    traversable: false,
    // Keep generic buildable false; mine buildings should explicitly check mine nodes.
    buildable: false,
  },
};

/**
 * Check if a terrain type is traversable by units.
 */
export function isTraversable(terrain: TerrainType): boolean {
  return TERRAIN_PROPERTIES[terrain].traversable;
}

/**
 * Check if a terrain type is buildable (can place buildings).
 */
export function isBuildable(terrain: TerrainType): boolean {
  return TERRAIN_PROPERTIES[terrain].buildable;
}
